const CAP_BITCOIN_TIMELINE = {
  title: "Línea del tiempo de Bitcoin (2007–2025)",
  sections: [
    {
      heading: "2007–2009 — Nace la idea y se lanza Bitcoin",
      text: [
        "Antes de ser una red real, Bitcoin empezó como una idea y un experimento de software.",
        "En estos primeros años se siembran las bases: el diseño del sistema, la publicación del documento técnico y el arranque de la red."
      ],
      bluepoint: [
        " **2007:** Satoshi Nakamoto comienza a trabajar en el concepto de Bitcoin y en el diseño del sistema de dinero electrónico peer-to-peer.",
        " **2008 (agosto):** se registra el dominio bitcoin.org de forma anónima.",
        " **2008 (octubre):** se publica el whitepaper “Bitcoin: A Peer-to-Peer Electronic Cash System”, donde se describe cómo evitar el doble gasto sin intermediarios.",
        " **2008 (noviembre):** el proyecto Bitcoin se registra como software libre en foros y repositorios de desarrolladores.",
        " **2009 (3 de enero):** se mina el bloque génesis (bloque 0), que marca el inicio oficial de la red Bitcoin.",
        " **2009 (enero):** se publica la versión 0.1 del software de Bitcoin y se realiza una de las primeras transacciones entre Satoshi Nakamoto y Hal Finney.",
        " **2009 (octubre):** se propone uno de los primeros tipos de cambio aproximados entre bitcoin y el dólar estadounidense en foros de la comunidad.",
        " **2009 (diciembre):** se lanza la versión 0.2 del software y la dificultad de minado empieza a ajustarse a medida que se conectan más mineros."
      ]
    },
    {
      heading: "2010–2012 — Primeras transacciones reales y mercados",
      text: [
        "En este periodo Bitcoin pasa de ser un experimento entre entusiastas a tener un precio de mercado y usos en el mundo real.",
        "También aparecen los primeros intercambios, comercios y conferencias."
      ],
      bluepoint: [
        " **2010 (febrero–marzo):** se crea uno de los primeros mercados de intercambio de bitcoin por dinero fiat.",
        " **2010 (mayo):** se realiza la famosa compra de dos pizzas por 10,000 BTC, considerada la primera transacción comercial conocida con bitcoin.",
        " **2010 (julio):** se lanza la versión 0.3 del software y el precio sube rápidamente desde fracciones de centavo hasta centavos de dólar.",
        " **2010 (julio):** se relanza Mt. Gox como uno de los primeros grandes exchanges de Bitcoin.",
        " **2010 (agosto):** un fallo de seguridad permite la creación de 184 mil millones de BTC; el problema se corrige y la cadena se reescribe pocas horas después.",
        " **2010 (noviembre):** la capitalización de mercado de Bitcoin supera por primera vez 1 millón de dólares.",
        " **2011 (febrero):** el precio de 1 BTC alcanza la paridad con 1 USD por primera vez.",
        " **2011 (abril–junio):** el precio sube por encima de 30 USD y luego sufre la primera gran burbuja y corrección fuerte.",
        " **2011 (diciembre):** el precio encuentra un suelo alrededor de 2 USD después de la caída.",
        " **2012 (septiembre):** se crean organizaciones y fundaciones dedicadas a la educación y desarrollo del ecosistema Bitcoin.",
        " **2012 (noviembre):** ocurre el primer halving de Bitcoin, reduciendo la recompensa de bloque de 50 BTC a 25 BTC."
      ]
    },
    {
      heading: "2013–2014 — Crecimiento, volatilidad y primeros grandes actores",
      text: [
        "Bitcoin entra cada vez más en el radar de medios, reguladores y empresas.",
        "El precio vive grandes subidas y bajadas, mientras aparecen los primeros cajeros y servicios comerciales."
      ],
      bluepoint: [
        " **2013 (febrero–abril):** el precio sube desde unos 20–30 USD hasta superar los 100 USD, alcanzando máximos cercanos a 266 USD antes de otra corrección.",
        " **2013 (marzo):** la capitalización de mercado de Bitcoin supera los 1,000 millones de dólares.",
        " **2013 (octubre):** se instala uno de los primeros cajeros automáticos (ATM) de Bitcoin abiertos al público.",
        " **2013 (octubre):** se cierra uno de los mercados más conocidos en la red oscura que aceptaba BTC, generando gran atención mediática.",
        " **2013 (noviembre):** el precio de Bitcoin alcanza un nuevo máximo histórico por encima de 1,000 USD.",
        " **2013 (diciembre):** algunas autoridades financieras comienzan a publicar advertencias sobre el riesgo de las criptomonedas.",
        " **2014 (enero):** el precio se mantiene volátil en rangos de cientos de dólares.",
        " **2014 (febrero):** uno de los principales exchanges de la época colapsa, afectando la confianza del mercado.",
        " **2014 (marzo):** se lanza la versión 0.9 de Bitcoin Core.",
        " **2014 (diciembre):** grandes empresas tecnológicas empiezan a aceptar bitcoin como medio de pago para productos digitales."
      ]
    },
    {
      heading: "2015–2016 — Consolidación de la red y segunda reducción de recompensa",
      text: [
        "Mientras el precio se estabiliza y el ecosistema se reacomoda tras los primeros escándalos, la red sigue creciendo técnicamente.",
        "Se mejora el software y se aproxima un nuevo halving."
      ],
      bluepoint: [
        " **2015 (febrero):** se lanza la versión 0.10 de Bitcoin con mejoras en el protocolo.",
        " **2015 (julio):** llega la versión 0.11, optimizando rendimiento y seguridad.",
        " **2015 (finales):** el precio empieza a recuperarse de forma sostenida, superando los 400–500 USD.",
        " **2016 (enero):** el precio ronda los 400–450 USD con volatilidad moderada.",
        " **2016 (julio):** ocurre el segundo halving, reduciendo la recompensa de 25 BTC a 12.5 BTC.",
        " **2016:** el hashrate alcanza niveles de exahashes por segundo, mostrando mayor seguridad.",
        " **2016:** comienzan a proliferar los primeros cajeros de Bitcoin en el mundo."
      ]
    },
    {
      heading: "2017–2019 — Auge, burbuja y maduración regulatoria",
      text: [
        "Bitcoin vive uno de sus ciclos de crecimiento más explosivos, seguido de una fuerte corrección.",
        "Paralelamente surgen muchas otras criptomonedas y se intensifica el interés regulatorio."
      ],
      bluepoint: [
        " **2017 (marzo):** se lanza la versión 0.14 de Bitcoin Core.",
        " **2017 (marzo):** el precio supera por primera vez el precio de una onza de oro.",
        " **2017 (agosto):** se activa SegWit, mejorando la eficiencia de las transacciones.",
        " **2017 (agosto):** ocurre la bifurcación que da origen a Bitcoin Cash (BCH).",
        " **2017 (noviembre–diciembre):** el precio alcanza máximos cercanos a 19,000–20,000 USD.",
        " **2018:** comienza el crypto winter con caídas importantes de precio y actividad.",
        " **2018–2019:** aumenta el interés regulatorio y surgen plataformas reguladas.",
        " **2019:** el precio se recupera parcialmente, aunque sin alcanzar los máximos de 2017."
      ]
    },
    {
      heading: "2020–2021 — Tercer halving, adopción institucional y nuevos máximos",
      text: [
        "Bitcoin comienza a considerarse una reserva digital de valor.",
        "Instituciones, empresas y fondos empiezan a interesarse de forma más abierta."
      ],
      bluepoint: [
        " **2020 (mayo):** tercer halving, recompensa pasa de 12.5 BTC a 6.25 BTC.",
        " **2020:** Bitcoin se posiciona como activo de cobertura ante la inflación durante la pandemia.",
        " **2021 (enero–abril):** el precio supera los 40,000 y luego los 60,000 USD.",
        " **2021 (septiembre):** El Salvador adopta bitcoin como moneda de curso legal.",
        " **2021 (finales):** el precio marca máximos cercanos o superiores a 60,000 USD."
      ]
    },
    {
      heading: "2022–2023 — Caída de mercado y crisis de confianza",
      text: [
        "Tras los máximos históricos, el mercado cripto vive un ciclo bajista con caídas severas y quiebras de empresas.",
        "Aun así, la red Bitcoin sigue operando sin interrupciones."
      ],
      bluepoint: [
        " **2022:** cae el precio de Bitcoin debido al contexto macroeconómico y quiebras de empresas cripto.",
        " **2022:** se refuerza la importancia de la autocustodia.",
        " **2023:** el mercado comienza a estabilizarse y se retoman discusiones sobre productos financieros regulados.",
        " **2023:** la red mantiene una dificultad de minado e hashrate históricamente altos."
      ]
    },
    {
      heading: "2024–2025 — Cuarto halving y consolidación como activo global",
      text: [
        "Bitcoin madura como infraestructura y como activo financiero.",
        "Se consolida la idea de que es una red global abierta y resistente a la censura."
      ],
      bluepoint: [
        " **2024 (enero):** Estados Unidos aprueba los primeros ETF spot de Bitcoin.",
        " **2024 (20 de abril):** cuarto halving, recompensa pasa de 6.25 BTC a 3.125 BTC.",
        " **2024–2025:** surgen más productos financieros regulados en distintos mercados.",
        " **2024–2025:** aumenta la integración de Bitcoin en billeteras y servicios tradicionales.",
        " **2025:** Bitcoin se considera una infraestructura digital madura y reconocida globalmente."
      ]
    }
  ]
};

export default CAP_BITCOIN_TIMELINE;
